import React from "react";
import Icon from "components/AppIcon";
import { RadialBarChart, RadialBar, ResponsiveContainer, Tooltip } from "recharts";

export default function VelocityMetrics({ kpis: kpisProp, velocityData: velocityDataProp }) {
  const metrics = (kpisProp || []).map((kpi, index) => {
    const colors = ["#3B82F6", "#10B981", "#F59E0B", "#8B5CF6"];
    return {
      ...kpi,
      sub: kpi.sub || kpi.subLabel,
      color: kpi.color || colors[index % colors.length],
    };
  });
  const rings = (velocityDataProp || []).map((ring) => ({
    ...ring,
    fill: ring?.fill || ring?.color || "#3B82F6",
  }));

  // Re-audit fix: each ring carries its own unit ('%', 'L' = ₹ lakh, '' = count)
  // so "Avg Deal Size" never renders as a percentage.
  const formatRing = (ring) => {
    if (ring?.unit === "L") return `₹${ring.value}L`;
    return `${ring.value}${ring?.unit ?? "%"}`;
  };

  return (
    <div
      className="card-base p-4 md:p-5"
      style={{ background: "var(--color-card)", border: "1px solid var(--color-border)" }}
    >
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className="font-heading font-semibold text-base" style={{ color: "var(--color-foreground)" }}>
            Sales Velocity
          </h3>
          <p className="text-xs font-caption mt-0.5" style={{ color: "var(--color-text-secondary)" }}>
            Key performance indicators
          </p>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-3 mb-4">
        {metrics?.map((kpi) => (
          <div
            key={kpi?.label}
            className="flex items-center gap-2.5 p-3 rounded-lg"
            style={{ background: "var(--color-muted)" }}
          >
            <div
              className="flex items-center justify-center rounded-lg flex-shrink-0"
              style={{ width: 32, height: 32, background: `${kpi?.color}18` }}
            >
              <Icon name={kpi?.icon} size={16} color={kpi?.color} />
            </div>
            <div className="min-w-0">
              <p className="text-base font-heading font-bold leading-tight" style={{ color: "var(--color-foreground)" }}>
                {kpi?.value}
              </p>
              <p className="text-xs font-caption truncate" style={{ color: "var(--color-text-secondary)" }}>
                {kpi?.label}
              </p>
            </div>
          </div>
        ))}
      </div>
      <div className="h-36">
        <ResponsiveContainer width="100%" height="100%">
          <RadialBarChart
            cx="50%"
            cy="50%"
            innerRadius="30%"
            outerRadius="90%"
            data={rings}
            startAngle={90}
            endAngle={-270}
          >
            <RadialBar dataKey="value" cornerRadius={4} background={{ fill: "var(--color-muted)" }} />
            <Tooltip
              formatter={(v, n) => {
                const ring = rings?.find((r) => r?.name === n);
                return [ring ? formatRing(ring) : `${v}%`, n];
              }}
              contentStyle={{ background: "var(--color-card)", border: "1px solid var(--color-border)", borderRadius: 8, fontSize: 11 }}
            />
          </RadialBarChart>
        </ResponsiveContainer>
      </div>
      <div className="flex items-center justify-around mt-2">
        {rings?.map((d) => (
          <div key={d?.name} className="flex items-center gap-1.5 text-xs font-caption">
            <span className="w-2.5 h-2.5 rounded-full flex-shrink-0" style={{ background: d?.fill }} />
            <span style={{ color: "var(--color-text-secondary)" }}>{d?.name}</span>
            <span className="font-data font-medium" style={{ color: "var(--color-foreground)" }}>{formatRing(d)}</span>
          </div>
        ))}
      </div>
    </div>
  );
}